export default __webpack_public_path__ + "static/media/assessment.9a604ecd.png";